module.exports = "<mat-toolbar>\r\n\r\n\r\n</mat-toolbar>\r\n"